import "@/App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormContextProvider } from "@/components/context/useFormContext";
import { LOAN_TYPE_BOAT } from "@/lib/constants";
import { QuickFormMain } from "@/components/forms/quickFormMain";

const queryClient = new QueryClient();

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const [component, setComponent] = useState<string | undefined>(undefined);
	const [siteTitle, setSiteTitle] = useState<string | undefined>(undefined);
	const [loan, setLoan] = useState<string | undefined>(undefined);

	useEffect(() => {
		const container = rootElement?.dataset.component ?? "boat";
		const siteTitle = rootElement?.dataset.title ?? "Jade Boat Loans";

		switch (container) {
			case "boat":
				setLoan(LOAN_TYPE_BOAT);
				break;
			default:
				setLoan(LOAN_TYPE_BOAT);
				break;
		}

		setSiteTitle(siteTitle);
		setComponent(container);
	}, [rootElement, siteTitle, loan]);

	const renderComponent = () => {
		return <QuickFormMain rootId={rootElement} loanTypes={loan} siteTitle={siteTitle} />;
	};

	return (
		<FormContextProvider id={rootElement}>
			<QueryClientProvider client={queryClient}>
				{siteTitle ? renderComponent() : <div>Loading...</div>}
			</QueryClientProvider>
		</FormContextProvider>
	);
}
